import CreateSubWinery from './CreateSubWinery';
import React from 'react';
import { useDispatch } from 'react-redux';
import { createSubWinery } from "../../../actions/subWineryActions";


export const CreateSubWineryContainer = ({match}) => {
    let idWarehouse = match.params.idWarehouse
    const dispatch = useDispatch();
    return (
        <div>
            <CreateSubWinery idWarehouse={idWarehouse} setData = {(values) => dispatch(createSubWinery(values,idWarehouse)) } />
        </div>
    )
}